import { Star } from "lucide-react";
import { motion } from "framer-motion";

export function FeaturedStays({ destination, stays }) {
  return (
    <section id="alojamientos" className="py-24" style={{ backgroundColor: "#f7f4ee" }}>
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true, margin: "-80px" }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12"
        >
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.28em] mb-2" style={{ color: "#E8470A" }}>
              Alojamientos destacados
            </p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-balance leading-tight" style={{ color: "#111827" }}>
              Los mejores lugares para quedarte en {destination}
            </h2>
          </div>
          <a
            href="#"
            className="flex-shrink-0 font-semibold px-6 py-3 rounded-full text-sm text-white transition-all duration-200 hover:opacity-90"
            style={{ backgroundColor: "#E8470A" }}
          >
            Ver todos →
          </a>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stays.map((stay, i) => (
            <motion.div
              key={stay.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
              viewport={{ once: true, margin: "-50px" }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="group rounded-2xl overflow-hidden"
              style={{ backgroundColor: "#ffffff", border: "1px solid #f0ece4", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={stay.image}
                  alt={stay.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.3), transparent)" }} />
                <span
                  className="absolute top-3 left-3 text-xs font-semibold px-2.5 py-1 rounded-full"
                  style={{ backgroundColor: "rgba(255,255,255,0.95)", color: "#374151" }}
                >
                  {stay.type}
                </span>
              </div>

              <div className="p-5">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h3 className="font-bold text-base leading-snug" style={{ color: "#111827" }}>
                    {stay.title}
                  </h3>
                  <div className="flex items-center gap-1 flex-shrink-0">
                    <Star className="w-3.5 h-3.5" style={{ fill: "#E8470A", color: "#E8470A" }} />
                    <span className="font-bold text-sm" style={{ color: "#111827" }}>{stay.rating}</span>
                  </div>
                </div>
                <p className="text-sm mb-4" style={{ color: "#9CA3AF" }}>{stay.location}</p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="font-extrabold text-lg" style={{ color: "#111827" }}>
                      ${stay.pricePerNight.toLocaleString("es-AR")}
                    </span>
                    <span className="text-sm" style={{ color: "#9CA3AF" }}> /noche</span>
                  </div>
                  <a
                    href="#"
                    className="text-sm font-semibold px-4 py-2 rounded-full text-white transition-colors duration-200"
                    style={{ backgroundColor: "#E8470A" }}
                  >
                    Ver
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
